import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MetaDefinition } from '@angular/platform-browser';
import { DynamicScriptLoaderService } from '@b2b/app/shared/services/dynamic-script-loader.service';
import { CompDetailService } from '@b2b/core/api/detail/detail.service';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';

declare var $: any;

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})

export class InfoComponent implements OnInit {
  compSlug: string;
  infoSlug: string;
  modules: any = [];
  isLoading: boolean = false;
  @ViewChildren('pdf') pdfLink: QueryList<any>;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public metaService: MetaService,
    private about: CompDetailService,
    private dynamicScriptLoader: DynamicScriptLoaderService,
    public imageOptimizer: ImageOptimizerService
  ) {}

  ngOnInit(): void {
    this.infoSlug = this.route.snapshot.params.info_slug;
    this.compSlug = this.route.parent.snapshot.params.comp_slug;
    this.getInfoModule();
    this.loadCss();
  }

  ngAfterViewInit(): void {
    this.loadScripts();
  }

  private async loadScripts() {
    // You can load multiple scripts by just providing the key as argument into load method of the service
    await this.dynamicScriptLoader.load('jquery', '0').then(data => {
      // Script Loaded Successfully

    }).catch(error => { });
    await this.dynamicScriptLoader.load('dflip', '1').then(data => {
      // Script Loaded Successfully
    }).catch(error => { });

    await this.dynamicScriptLoader.load('three', '2').then(data => {
      // Script Loaded Successfully
    }).catch(error => { });
  }

  private async loadCss() {
    // You can load multiple scripts by just providing the key as argument into load method of the service
    await this.dynamicScriptLoader.load('dflipCss', '3').then(data => {
      // Script Loaded Successfully
    }).catch(error => { });
    await this.dynamicScriptLoader.load('themify', '4').then(data => {
      // Script Loaded Successfully
    }).catch(error => { });
  }

  ngDoCheck(): void {
    if (this.infoSlug !== this.route.snapshot.params.info_slug) {
      this.infoSlug = this.route.snapshot.params.info_slug;
      this.getInfoModule();
    }
  }


  getInfoModule(): void {
    this.isLoading = true;
    this.about.getCompTextModule(this.compSlug, this.infoSlug).subscribe(
      (response) => {
        this.modules = response;
        this.updateMetaInfo();
        this.isLoading = false;
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );
  }

  updateMetaInfo(): void {
    this.about.fetchCompetition(this.compSlug, (competition) => {
      let metaInfo: MetaDefinition[] = [];

      const title = `${competition.title} ${competition.disciplines[0]?.name} Competition | ${competition.location?.name ?
        competition.location.name : competition.location?.country?.name} | ${this.infoSlug.charAt(0).toUpperCase() +
        this.infoSlug.slice(1)}`;
      const description = `${competition.tagline}. ${this.modules[0].desc.substring(0, 100)}`;
      const image = competition.image ?  this.renderImage(competition.image) : '';
      metaInfo = [
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'url', content: window.location.href },
        { name: 'image', content: image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:url', content: window.location.href },
        { name: 'twitter:image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: window.location.href },
        { property: 'og:image', content: image },
        { property: 'og:image:alt', content: title },
        { property: 'og:type', content: 'website' }
      ];
      metaInfo.forEach(meta => {
        this.metaService.updateMetaInfo(meta);
      });
      this.metaService.updateMeta(metaInfo);
      this.metaService.updateTitle(title);
      this.metaService.createCanonicalURL();
    });
  }

  loadPdfReader(index: number): void {
    this.pdfLink.toArray()[index].nativeElement.click();
  }

  openLink(link: string): void {
    window.open(link, '_blank');
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }
}
